import { RequiredParamException } from "api/exceptions/InvalidParamException";
import AccessProfileModel from "api/models/AccessProfileModel";
import AccessProfileRepository from "api/repositories/AccessProfileRepository";

class AccessProfileService {
  public async addAccessProfile(
    companyUid: string,
    data: { name: string; permissions: string[] }
  ): Promise<string> {
    if (!companyUid) throw new RequiredParamException("companyUid");
    const profile = AccessProfileModel.create("", data);
    return AccessProfileRepository.addAccessProfileToDataBase(
      companyUid,
      profile
    );
  }

  public async getAccessProfileByUid(
    companyUid: string,
    profileUid: string
  ): Promise<AccessProfileModel | undefined> {
    if (!companyUid || !profileUid) return;
    return await AccessProfileRepository.getAccessProfileFromDatabaseByUid(
      companyUid,
      profileUid
    );
  }

  public async deleteAccessProfile(
    companyUid: string,
    profileUid: string
  ): Promise<void> {
    if (!companyUid || !profileUid) return;
    return await AccessProfileRepository.deleteAccessProfileFromDataBase(
      companyUid,
      profileUid
    );
  }

  public async updateAccessProfile(
    companyUid: string,
    profileUid: string,
    data: { name: string; permissions: string[] }
  ): Promise<void> {
    if (!companyUid || !profileUid) return;
    return AccessProfileRepository.updateAccessProfileOnDataBase(
      companyUid,
      profileUid,
      data
    );
  }

  public subscribeAccessProfilesByCompany(
    companyUid: string,
    onCreate: (data?: AccessProfileModel[]) => void,
    onChange: (data?: AccessProfileModel[]) => void,
    onRemove: (data?: AccessProfileModel[]) => void
  ) {
    if (!companyUid) return;

    return AccessProfileRepository.addAccessProfilesCollectionSnapshot(
      companyUid,
      onCreate,
      onChange,
      onRemove
    );
  }
}

export default new AccessProfileService();
